import { Select, message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import storeApi from '../../apis/store';
import {
  getActiveStoreId,
  setActiveStoreId,
} from '../../constants/store';
import { IStore } from '../../interfaces/Store';
import { RootState } from '../../reducers';
import { Role } from '../../role/role';

const SwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 16px;
`;

const StoreLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--color-light-grey, #667085);
  white-space: nowrap;
`;

const StoreSelect = styled(Select)`
  min-width: 180px;
`;

const StoreSwitcher = () => {
  const { authUser, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );
  const [stores, setStores] = useState<IStore[]>([]);
  const [activeStoreId, setActiveId] = useState<string | undefined>();

  const loadStores = useCallback(async () => {
    if (!isAuthenticated || authUser?.role !== Role.SELLER) {
      return;
    }

    try {
      const list = await storeApi.listStores();
      setStores(list);

      const saved = getActiveStoreId();
      const stillValid = list.find((s) => s.id === saved);
      const next =
        stillValid?.id ||
        list.find((s) => s.isDefault)?.id ||
        list[0]?.id;

      if (next) {
        setActiveStoreId(next);
        setActiveId(next);
      }
    } catch (e: any) {
      message.error(e?.message || 'Failed to load stores');
    }
  }, [authUser?.role, isAuthenticated]);

  useEffect(() => {
    loadStores();
  }, [loadStores]);

  if (!isAuthenticated || authUser?.role !== Role.SELLER || stores.length === 0) {
    return null;
  }

  return (
    <SwitcherWrapper>
      <StoreLabel>Chọn Store</StoreLabel>
      <StoreSelect
        value={activeStoreId}
        placeholder="Select store"
        options={stores.map((store) => ({
          label: store.isDefault ? `${store.name} (default)` : store.name,
          value: store.id,
        }))}
        onChange={(value: any) => {
          setActiveStoreId(value);
          setActiveId(value);
        }}
      />
    </SwitcherWrapper>
  );
};

export default StoreSwitcher;
